import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Page from "app/pages/.shared/Page/Page";
import { Route, Routes } from "react-router-dom";
import TechnicalErrorRegistrationExpired from "./registration/expired/TechnicalErrorRegistrationExpired";
import TechnicalErrorRegistrationErrorDefault from "./registration/default/TechnicalErrorRegistrationErrorDefault";
import TechnicalErrorDefault from "./default/TechnicalErrorDefault";
import TechnicalErrorSSO from "./sso/TechnicalErrorSSO";
import { STRATEGY } from "app/constants";
import { strategyShape } from "app/utils/propTypes";
import TechnicalErrorDuplicateBookingContainer from "app/pages/TechnicalError/duplicateBooking/TechnicalErrorDuplicateBookingContainer";

import "./TechnicalError.scss";

const TechnicalError = ({
	strategy,
	isDoubleOptin,
	teasingEndDate,
	isWhiteLabel,
	shop,
	brandDisplayName,
	errorMessage = "",
	fallbackRedirectUrl,
}) => {
	return (
		<div className="technical-errors">
			<Routes>
				{isDoubleOptin && (
					<Route
						path="/registration-confirmation-expired"
						element={
							<Page title={<FormattedMessage id="technical.error.title" />}>
								<TechnicalErrorRegistrationExpired
									teasingEndDate={teasingEndDate}
								/>
							</Page>
						}
					/>
				)}
				{isDoubleOptin && (
					<Route
						path="/confirm-registration-failed"
						element={
							<Page title={<FormattedMessage id="technical.error.title" />}>
								<TechnicalErrorRegistrationErrorDefault />
							</Page>
						}
					/>
				)}
				{strategy === STRATEGY.OAUTH && (
					<Route
						path="/sso"
						element={
							<Page title={<FormattedMessage id="technical.sso.error.title" />}>
								<TechnicalErrorSSO />
							</Page>
						}
					/>
				)}
				<Route
					path="/duplicate-booking"
					element={
						<Page
							title={
								<FormattedMessage id="technical.error.duplicate.booking.title" />
							}
						>
							<TechnicalErrorDuplicateBookingContainer
								isWhiteLabel={isWhiteLabel}
								shop={shop}
							/>
						</Page>
					}
				/>
				<Route
					path="/*"
					element={
						<Page title={<FormattedMessage id="technical.error.title" />}>
							<TechnicalErrorDefault
								errorMessage={errorMessage}
								brandDisplayName={brandDisplayName}
								fallbackRedirectUrl={fallbackRedirectUrl}
							/>
						</Page>
					}
				/>
			</Routes>
		</div>
	);
};

TechnicalError.propTypes = {
	isDoubleOptin: PropTypes.bool,
	brandDisplayName: PropTypes.string,
	teasingEndDate: PropTypes.string,
	isWhiteLabel: PropTypes.bool,
	shop: PropTypes.string,
	errorMessage: PropTypes.string,
	strategy: strategyShape,
	fallbackRedirectUrl: PropTypes.string,
};

export default TechnicalError;
